<template>
  <div class="view-offers-map" :class="{ 'is-opened': isOpen }">
    <div class="view-offers-map__map-wrapper">
      <div class="view-offers-map__map" :key="customKey">
        <div
          class="view-offers-map__map-close"
          @click="handleClose"
          v-if="isOpen"
        >
          <app-svg-icon
            class="view-offers-map__map-close-icon"
            name="close"
          ></app-svg-icon>
        </div>

        <div class="view-offers-map__overlay" v-show="!isOpen">
          <app-button-control
            @click="handleShow"
            class="view-offers-map__button-show"
            type="secondary"
          >
            Показать предложения на карте
            <app-svg-icon
              class="view-offers-map__button-show-icon"
              name="size"
            ></app-svg-icon>
          </app-button-control>
        </div>
        <yandex-map
          ref="map"
          v-if="isMapReady"
          :key="+isOpen"
          :scroll-zoom="true"
          @map-was-initialized="initMap"
          @actionend="actionend"
          ymap-class="view-offers-map__map-component"
          :coords="coords"
          :show-all-markers="true"
          :init-without-markers="true"
          :use-html-in-layout="true"
          :controls="controls"
          @click="clickMap"
        >
          <ymap-marker
            v-for="(item, index) in response"
            :key="item.id"
            :coords="coordsToArray(item.warehouse.location)"
            :marker-id="index"
            marker-type="placemark"
            :icon="markerIcon(item)"
            :options="{
              hideIconOnBalloonOpen: false,
              balloonOffset: [-45, -35],
            }"
            :hint-content="item.warehouse.name"
            ><view-offers-balloon
              :item="item"
              slot="balloon"
            ></view-offers-balloon>
          </ymap-marker>
        </yandex-map>
      </div>
      <div class="view-offers-map__filters">
        <div class="view-offers-map__filters-col">
          <app-dropdown-addresses
            :isAuth="false"
            @save="isSaveAddress = $event"
            :showMyLocation="false"
            :address="{
              id: delivery.addressId,
              address: delivery.address,
              location: delivery.location,
            }"
            @address="getAddress"
            tooltip="Укажите адрес, по которому необходимо доставить продукцию."
          ></app-dropdown-addresses>
        </div>
        <div class="view-offers-map__filters-col">
          <app-my-location
            class="view-offers-map__filter-location"
            icon="navigation-line"
            text="Использовать моё местоположение"
            @click="selectYandexAddress"
          ></app-my-location>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { offersMapper } from '@/store/offers';
import { rootMapper } from '@/store/root';

export default {
  name: 'ViewOffersMap',
  components: {
    AppButtonControl: () => import('@/components/ui/AppButtonControl'),
    AppSvgIcon: () => import('@/components/common/AppSvgIcon'),
    AppDropdownAddresses: () =>
      import('@/components/dropdowns/AppDropdownAddresses'),
    AppMyLocation: () => import('@/components/ui/AppMyLocation'),
    ViewOffersBalloon: () => import('@/pages/offers/ViewOffersBalloon'),
  },
  props: {
    response: {
      type: Array,
      required: true,
    },
    isOpen: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    bounds: null,
    coords: [0, 0],
    customKey: 0,
    myMap: null,
    isMapReady: false,
    isSaveAddress: false,
    delivery: {
      address: '',
      location: null,
    },
    controls: ['zoomControl', 'geolocationControl', 'fullscreenControl'],
  }),
  computed: {
    ...offersMapper.mapState(['filterData']),
    ...offersMapper.mapState(['offersListDelivery']),
  },
  watch: {
    offersListDelivery: {
      deep: true,
      handler() {
        this.customKey += 1;
      },
    },
  },

  created() {
    this.isMapReady = true;
  },
  methods: {
    ...rootMapper.mapMutations(['SET_USER_SAVE_ADDRESS_COORDS']),
    /**
     * Получение данных адреса
     * @param {Object} address
     */
    getAddress(address) {
      if (address?.address && address.location) {
        this.delivery.address = address.address;
        this.delivery.location = address.location;
        this.SET_USER_SAVE_ADDRESS_COORDS(address.location);
      }
    },
    getLogoPath(item) {
      return `/static/images/logos/${
        item.sellerContractor?.id ? item.sellerContractor.id : 0
      }.png`;
    },
    selectYandexAddress(address) {
      const location = address.location.replace(/\s+/g, '');
      this.SET_USER_SAVE_ADDRESS_COORDS(location);
    },
    /**
     * Стиль маркера
     */
    markerIcon(item) {
      return {
        layout: 'default#imageWithContent',
        imageOffset: [-90, -40],
        imageSize: [90, 40],
        contentLayout: `
        <div style="position:relative;background:#fff;display:flex;align-items:center;width:90px;height:40px;pointer-events:none;border:solid 2px #29c471;padding:6px;border-radius:10px">
         <img src="${this.getLogoPath(
           item
         )}" style="display:block;margin:0 auto;max-width:100%;max-height:100%"/>
         <div style="background:#44cd7f;color:#fff;border-radius:5px;transform:translateX(1px);padding:2px 4px;font-size:11px;font-weight:bold">${
           +item.items.length + 1
         }</div>
         </div>`,
      };
    },
    /**
     * Развернуть карту
     */
    handleShow() {
      this.$emit('handleShow');
    },
    /**
     * свернуть карту
     */
    handleClose() {
      this.$emit('handleClose');
    },
    /**
     * Конвертер координат в массив чисел
     */
    coordsToArray(coords) {
      if (!coords) {
        return [52.858254, 27.701402];
      }
      return coords.split(',').map((el) => +el);
    },
    /**
     * Клик по карте
     */
    clickMap() {
      // console.log('clickMap');
    },
    /**
     * Изменение карты
     */
    actionend() {
      if (this.myMap.getZoom() > 14) this.myMap.setZoom(14);
    },
    /**
     * Событие инициализации карты
     * @param payload
     */
    initMap(payload) {
      this.myMap = payload;
    },
  },
};
</script>

<style lang="scss">
.view-offers-map {
  $root: &;

  &__map-wrapper {
    position: relative;
  }

  &__map {
    position: relative;
    width: 100%;
    height: 185px;
  }

  &__placeholder {
    border: solid 2px #000;

    img {
      display: block;
    }
  }

  &__filters {
    position: absolute;
    right: 10px;
    bottom: 10px;
    left: 10px;
    z-index: 2;
    display: none;

    @include media-xs() {
      position: relative;
      right: initial;
      bottom: initial;
      left: initial;
      flex-wrap: wrap;
      margin-right: 0;
      margin-left: 0;
      background: #fff;
      border-bottom-right-radius: 12px;
      border-bottom-left-radius: 12px;
    }
  }

  &__filter-location {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    min-height: 48px;
    font-size: 16px !important;
    font-weight: 500 !important;
    color: #12b969;
    text-align: center;
    cursor: pointer;
    background: transparent;
    border: none;

    @include media-xs() {
      font-size: 14px !important;
    }

    svg {
      flex-shrink: 0;
      width: 22px !important;
      height: 22px !important;
      margin-right: 12px !important;
      fill: #12b969;

      @include media-xs() {
        width: 18px !important;
        height: 18px !important;
        margin-right: 7px !important;
      }
    }
  }

  &__filters-col {
    width: calc(50% - 20px);
    padding: 10px;
    margin: 10px;
    background: #fff;
    border-radius: 3px;
    box-shadow: 0 1px 18px 0 rgba(0, 0, 0, 0.07);

    @include media-xs() {
      width: 100%;
      margin: 0;
      background: transparent;
      border-radius: none;
      box-shadow: none;
    }
  }

  &__map-component {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    overflow: hidden;
    background: #f5f5f5;
    border-radius: 12px;
  }

  &__button-show {
    display: flex;
    align-items: center;
    height: 76px;
    margin: auto auto 0;
    font-size: 21px;

    @include media-md() {
      height: 55px;
      font-size: 18px;
    }

    @include media-xs() {
      height: 50px;
      padding: 0 15px;
      font-size: 14px;
    }
  }

  &__button-show-icon {
    flex-shrink: 0;

    @include size(20px);

    margin-left: 16px;
    fill: $white;
  }

  &__overlay {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1;
    display: flex;
    flex-direction: column;
    background-image: linear-gradient(
      0deg,
      rgba(#fafafa, 1) 0%,
      rgba(#fafafa, 0.8) 50%,
      rgba(#fafafa, 0) 100%
    );
  }

  &__map-close {
    position: absolute;
    right: 0;
    bottom: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    @include size(30px);

    cursor: pointer;
    background-image: linear-gradient(
      0deg,
      rgb(43, 202, 109) 0%,
      rgb(14, 187, 99) 100%
    );
  }

  &__map-close-icon {
    @include size(14px);

    fill: $white;
  }

  &.is-opened {
    #{$root}__filters {
      display: flex;
    }
    #{$root}__map {
      height: 800px;

      @include media-md() {
        height: 500px;
      }

      @include media-xs() {
        height: 400px;
      }
    }
  }
}

.ymaps-2-1-79-balloon {
  box-shadow: none !important;
}

.ymaps-2-1-79-balloon__layout {
  border: solid 2px #29c471;
}

.ymaps-2-1-79-balloon__tail {
  display: none !important;
}

.ymaps-2-1-79-balloon__content {
  padding: 15px;
}

.ymaps-2-1-79-balloon__content,
.ymaps-2-1-79-balloon__layout {
  border-radius: 12px;
}

.ymaps-2-1-79-copyright,
.ymaps-2-1-79-map-copyrights-promo {
  display: none !important;
}
</style>
